(function () {
  'use strict';

  var MODAL_SELECTOR = '[data-quick-add-modal]';
  var OPEN_SELECTOR = '[data-quick-add-open]';
  var BODY_OPEN_CLASS = 'oddit-quick-add-open';
  var TEMPLATE_VIEW = 'oddit-quick-add';

  var lastTrigger = null;
  var currentRequest = 0;
  var inFlight = false;

  function getModal() {
    return document.querySelector(MODAL_SELECTOR);
  }

  function buildTemplateUrl(productUrl) {
    var base = productUrl.split('#')[0];
    var separator = base.indexOf('?') === -1 ? '?' : '&';
    return base + separator + 'view=' + TEMPLATE_VIEW;
  }

  function setBusy(button) {
    var restWidth = button.getBoundingClientRect().width;
    if (restWidth > 0) button.style.minWidth = restWidth + 'px';
    button.disabled = true;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
  }

  function clearBusy(button) {
    button.disabled = false;
    button.classList.remove('is-loading');
    button.removeAttribute('aria-busy');
    button.style.minWidth = '';
  }

  function showError(root, message) {
    var el = root.querySelector('[data-quick-add-error]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  }

  function clearError(root) {
    var el = root.querySelector('[data-quick-add-error]');
    if (!el) return;
    el.textContent = '';
    el.hidden = true;
  }

  function addVariantToCart(variantId) {
    if (window.OdditCartDrawer && typeof window.OdditCartDrawer.addToCart === 'function') {
      return window.OdditCartDrawer.addToCart(variantId, 1).then(function () {
        return true;
      });
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart request failed');
        return res.json();
      })
      .then(function () {
        return false;
      });
  }

  function announceCart(drawerRefreshed) {
    if (!drawerRefreshed) document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:open'));
  }

  function parseVariants(root) {
    var node = root.querySelector('[data-quick-add-variants]');
    if (!node) return [];
    try {
      var parsed = JSON.parse(node.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (err) {
      return [];
    }
  }

  function readSelection(root, optionCount) {
    var selection = [];
    for (var i = 0; i < optionCount; i++) {
      var active = root.querySelector(
        '.oddit-quick-add__option-btn--active[data-quick-add-option="' + (i + 1) + '"]'
      );
      selection.push(active ? active.getAttribute('data-quick-add-value') : null);
    }
    return selection;
  }

  function firstSellable(variants) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) return variants[i];
    }
    return variants[0] || null;
  }

  function findVariant(variants, selection) {
    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      var match = true;
      for (var j = 0; j < selection.length; j++) {
        if (selection[j] === null || variant.options[j] !== selection[j]) {
          match = false;
          break;
        }
      }
      if (match) return variant;
    }
    return null;
  }

  function updateOptionAvailability(root, variants, selection) {
    root.querySelectorAll('[data-quick-add-option]').forEach(function (button) {
      var position = Number(button.getAttribute('data-quick-add-option')) - 1;
      var value = button.getAttribute('data-quick-add-value');

      var available = variants.some(function (variant) {
        if (!variant.available) return false;
        if (variant.options[position] !== value) return false;
        for (var i = 0; i < selection.length; i++) {
          if (i === position) continue;
          if (selection[i] !== null && variant.options[i] !== selection[i]) return false;
        }
        return true;
      });

      button.classList.toggle('oddit-quick-add__option-btn--unavailable', !available);
    });
  }

  function syncState(root, variants) {
    var optionCount = Number(root.getAttribute('data-option-count')) || 0;
    var submit = root.querySelector('[data-quick-add-submit]');
    if (!submit) return;

    var selection = readSelection(root, optionCount);
    var variant = optionCount ? findVariant(variants, selection) : firstSellable(variants);

    root.querySelectorAll('[data-quick-add-option-value]').forEach(function (el) {
      var position = Number(el.getAttribute('data-quick-add-option-value')) - 1;
      if (selection[position]) el.textContent = selection[position];
    });

    updateOptionAvailability(root, variants, selection);

    var priceEl = root.querySelector('[data-quick-add-price]');
    var compareEl = root.querySelector('[data-quick-add-compare-price]');
    var label = submit.querySelector('[data-button-label]');

    if (!variant) {
      submit.removeAttribute('data-variant-id');
      submit.disabled = true;
      if (label) label.textContent = submit.getAttribute('data-unavailable-label') || 'Unavailable';
      return;
    }

    submit.setAttribute('data-variant-id', variant.id);
    submit.disabled = !variant.available;
    if (label) {
      label.textContent = variant.available
        ? submit.getAttribute('data-add-label') || 'add to cart'
        : submit.getAttribute('data-sold-out-label') || 'Sold out';
    }

    if (priceEl && variant.price) {
      priceEl.textContent = variant.price;
      priceEl.classList.toggle('oddit-quick-add__price-value--sale', Boolean(variant.compare_at_price));
    }

    if (compareEl) {
      if (variant.compare_at_price) {
        compareEl.textContent = variant.compare_at_price;
        compareEl.hidden = false;
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
      }
    }
  }

  function initContent(modal) {
    var root = modal.querySelector('[data-quick-add-product]');
    if (!root) return;

    var variants = parseVariants(root);

    root.addEventListener('click', function (e) {
      var button = e.target.closest && e.target.closest('[data-quick-add-option]');
      if (!button || !root.contains(button)) return;

      var position = button.getAttribute('data-quick-add-option');
      root
        .querySelectorAll('[data-quick-add-option="' + position + '"]')
        .forEach(function (sibling) {
          var isTarget = sibling === button;
          sibling.classList.toggle('oddit-quick-add__option-btn--active', isTarget);
          sibling.setAttribute('aria-pressed', isTarget ? 'true' : 'false');
        });

      clearError(root);
      syncState(root, variants);
    });

    root.addEventListener('click', function (e) {
      var submit = e.target.closest && e.target.closest('[data-quick-add-submit]');
      if (!submit || !root.contains(submit) || submit.disabled) return;

      e.preventDefault();
      if (inFlight) return;

      var variantId = Number(submit.getAttribute('data-variant-id'));
      if (!variantId) return;

      inFlight = true;
      clearError(root);
      setBusy(submit);

      addVariantToCart(variantId)
        .then(function (drawerRefreshed) {
          closeModal(getModal());
          announceCart(drawerRefreshed);
        })
        .catch(function () {
          showError(root, 'Sorry, we could not add that to your cart. Please try again.');
        })
        .then(function () {
          inFlight = false;
          clearBusy(submit);
        });
    });

    syncState(root, variants);
  }

  function renderLoader(modal) {
    var content = modal.querySelector('[data-quick-add-content]');
    if (!content) return;
    content.innerHTML =
      '<div class="oddit-quick-add__loader" data-quick-add-loader>' +
      '<span class="oddit-quick-add__spinner" aria-hidden="true"></span>' +
      '<span class="oddit-quick-add__visually-hidden">Loading product</span>' +
      '</div>';
  }

  function renderFailure(modal, productUrl) {
    var content = modal.querySelector('[data-quick-add-content]');
    if (!content) return;
    content.innerHTML =
      '<div class="oddit-quick-add__failure">' +
      '<p class="oddit-quick-add__failure-text">We could not load this product.</p>' +
      '<a class="oddit-quick-add__failure-link" href="' + productUrl + '">View full details</a>' +
      '</div>';
  }

  function loadProduct(modal, productUrl) {
    var token = ++currentRequest;
    renderLoader(modal);

    fetch(buildTemplateUrl(productUrl), {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Quick add request failed');
        return res.text();
      })
      .then(function (html) {
        if (token !== currentRequest) return;
        var content = modal.querySelector('[data-quick-add-content]');
        if (!content) return;
        content.innerHTML = html;
        initContent(modal);
        focusDialog(modal);
      })
      .catch(function () {
        if (token !== currentRequest) return;
        renderFailure(modal, productUrl);
      });
  }

  function focusDialog(modal) {
    var target = modal.querySelector('.oddit-quick-add__close');
    if (target) target.focus();
  }

  function trapFocus(modal, e) {
    var focusable = modal.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function openModal(modal, trigger, productUrl) {
    if (!modal) return;
    lastTrigger = trigger || null;
    modal.removeAttribute('hidden');
    document.body.classList.add(BODY_OPEN_CLASS);
    focusDialog(modal);
    loadProduct(modal, productUrl);
  }

  function closeModal(modal) {
    if (!modal || modal.hasAttribute('hidden')) return;
    currentRequest++;
    modal.setAttribute('hidden', '');
    document.body.classList.remove(BODY_OPEN_CLASS);
    renderLoader(modal);
    if (lastTrigger) {
      lastTrigger.focus();
      lastTrigger = null;
    }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest(OPEN_SELECTOR);
    if (!trigger || trigger.disabled) return;

    e.preventDefault();
    e.stopPropagation();

    var directVariant = trigger.getAttribute('data-quick-add-variant-id');
    var productUrl = trigger.getAttribute('data-quick-add-url');

    if (directVariant) {
      if (inFlight) return;
      inFlight = true;
      setBusy(trigger);

      addVariantToCart(Number(directVariant))
        .then(announceCart)
        .catch(function () {})
        .then(function () {
          inFlight = false;
          clearBusy(trigger);
        });
      return;
    }

    if (!productUrl) return;
    openModal(getModal(), trigger, productUrl);
  });

  document.addEventListener('click', function (e) {
    var closer = e.target.closest && e.target.closest('[data-quick-add-close]');
    if (!closer) return;
    e.preventDefault();
    closeModal(closer.closest(MODAL_SELECTOR));
  });

  document.addEventListener('keydown', function (e) {
    var modal = getModal();
    if (!modal || modal.hasAttribute('hidden')) return;

    if (e.key === 'Escape') {
      closeModal(modal);
      return;
    }

    if (e.key === 'Tab') trapFocus(modal, e);
  });

  document.addEventListener('cart:open', function () {
    closeModal(getModal());
  });
})();
